import { ButtonProps } from '@chakra-ui/react';
import React from 'react';
import { ChakraComponents } from '../../lib/chakra';
import AppLoader from '../Loader';

type Props = {
  children: React.ReactNode,
  type?: 'button' | 'submit',
  loading?: boolean,
  [x: string]: any,
} & ButtonProps;

const CustomButton = ({ children, type, loading, ...rest }: Props) => {
  return (
    <>
      <ChakraComponents.Button
        type={type || 'button'}
        colorScheme={'facebook'}
        isDisabled={loading}
        {...rest}
      >
        {!loading ? children : <AppLoader color="white" />}
      </ChakraComponents.Button>
    </>
  );
};

export default CustomButton;
